import { render, staticRenderFns } from "./b-popup-account.vue?vue&type=template&id=4182f1d2&scoped=true"
import script from "./b-popup-account.vue?vue&type=script&lang=js"
export * from "./b-popup-account.vue?vue&type=script&lang=js"
import style0 from "./b-popup-account.vue?vue&type=style&index=0&id=4182f1d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182f1d2",
  null
  
)

export default component.exports